import { Form } from 'semantic-ui-react'
import styled from 'styled-components'

export const StyledCheckbox = styled(Form.Field)`
    line-height: 1em !important;
    label {
        font-weight: 400 !important;
    }
`
